<template>
  <div class="main-container">
      <Button class="back-btn" type="primary" ghost @click="back('/orderManage/group/peservation')">返回</Button>
      <loading :isShow="listLoading" />
      <div class="table">
          <div class="title">
              <div class="left-line"></div>
              <div class="title-desc">保单信息</div>
          </div>
          <div class="table-info">
              <div class="table-left">
                  <div class="label">保险产品</div>
                  <div class="value">{{ infoData.productName }}</div>
              </div>
              <div class="table-right">
                  <div class="label">投保企业名称</div>
                  <div class="value">{{ infoData.holderName }}</div>
              </div>
          </div>
          <div class="table-info">
              <div class="table-left">
                  <div class="label">保单号</div>
                  <div class="value">{{ infoData.policyNo }}</div>
              </div>
              <div class="table-right">
                  <div class="label">保单生效日</div>
                  <div class="value">{{ infoData.policyStartTime && infoData.policyStartTime.substr(0, 10) }}</div>
              </div>
          </div>
          <div class="table-info b-border">
              <div class="table-left">
                  <div class="label">保单终止日</div>
                  <div class="value">{{ infoData.policyEndTime && infoData.policyEndTime.substr(0, 10) }}</div>
              </div>
              <div class="table-right">
                  <div class="label"></div>
                  <div class="value"></div>
              </div>
          </div>
      </div>

      <div class="table">
          <div class="title">
              <div class="left-line"></div>
              <div class="title-desc">批改信息</div>
          </div>
          <div class="table-info">
              <div class="table-left">
                  <div class="label">批单号</div>
                  <div class="value">{{ infoData.billNo }}</div>
              </div>
              <div class="table-right">
                  <div class="label">状态</div>
                  <div class="value">{{ statusMap[infoData.status] }}</div>
              </div>
          </div>
          <div class="table-info">
              <div class="table-left">
                  <div class="label">批单生效日期</div>
                  <div class="value">{{ infoData.endorsementStartTime && infoData.endorsementStartTime.substr(0, 10) }}</div>
              </div>
              <div class="table-right">
                  <div class="label">批改保费（元）</div>
                  <div class="value">{{ infoData.fee }}</div>
              </div>
          </div>
          <div class="table-info b-border">
              <div class="table-left">
                  <div class="label">变更内容</div>
                  <div class="value">
                    <span v-if="infoData.addCounts">加{{ infoData.addCounts }}人</span>
                    <span v-if="infoData.addCounts&&infoData.delCounts">，</span>
                    <span v-if="infoData.delCounts">减{{ infoData.delCounts }}人</span>
                  </div>
              </div>
              <div class="table-right">
                  <div class="label"></div>
                  <div class="value"></div>
              </div>
          </div>
      </div>

      <div class="table">
          <div class="title">
              <div class="left-line"></div>
              <div class="title-desc">批改清单</div>
          </div>
          <Table :columns="columns" :data="tableData">
            <template slot-scope="{ row }" slot="cardNoMask">
                <div>
                  <span v-if="!row.eyeShow1">{{ row.cardNoMask }}</span>
                  <span v-else>{{ row.cardNoMask1 }}</span>
                  <span v-if="row.cardNoMask">
                    <i class="iconfont iconxianshi eye-icon" v-if="row.eyeShow1" @click="openEye(row, 'eyeShow1', 'cardNoMask')"></i>
                    <i class="iconfont iconyincang eye-icon" v-else @click="openEye(row, 'eyeShow1', 'cardNoMask')"></i>
                  </span>
                </div>
              </template>
          </Table>
      </div>
      <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="pageChange" style="text-align: center" />
  </div>
</template>

<script>
let typeMap = {
  1: '增保',
  2: '替保',
  3: '减保'
};

import { common } from '@/api/mixins';
export default {
  mixins: [common],
  data() {
      return {
          listLoading: false,
          infoData: {},
          statusMap: {
              '-20': '批改失败',
              '-15': '核保失败',
              0: '待提交',
              20: '待支付/确认',
              30: '待实收',
              40: '待承保',
              50: '已完成',
              '-99': '保全撤销'
          },
          total: 0,
          pageNum: 1,
          pageSize: 10,
          tableData: [],
          columns: [
              {
                  title: '姓名',
                  key: 'name',
                  minWidth: 100,
                  align: 'center'
              },
              {
                  title: '证件号',
                  slot: 'cardNoMask',
                  minWidth: 180,
                  align: 'center',
              },
              {
                  title: '保全类型',
                  key: 'endorsementType',
                  minWidth: 100,
                  align: 'center',
                  render(h, params) {
                      return <span> {typeMap[params.row.endorsementType]}</span>;
                  }
              },
              {
                  title: '职业类别',
                  key: 'jobGrade',
                  minWidth: 180,
                  align: 'center',
                  render(h, params) {
                      const jobGrade = params.row.jobGrade;
                      return <span>{jobGrade ? jobGrade : '-'}</span>;
                  }
              },
              {
                  title: '保障计划',
                  key: 'planName',
                  minWidth: 180,
                  align: 'center',
                  render(h, params) {
                      const planName = params.row.planName;
                      return <span>{planName ? planName : '-'}</span>;
                  }
              },
              {
                  title: '生效时间',
                  minWidth: 180,
                  align: 'center',
                  render(h, params) {
                    let startTime = params.row.startTime.substring(0, 10);
                    return <span>{startTime}</span>;
                  }
              }
          ]
      };
  },

  created() {
      this.getInfoList();
      this.getPersonneList();
  },

  methods: {
    openEye(item,keyName,name){
      if (!item[keyName]) {
        this.descrypt(
          {
            query: item.id,
            operationFunction: 18,
            operationType: 1
          },
          item,
          name + '1',
          'order_40_2_5'
        ).then(() => {
          this.$set(item, keyName, true);
        });
      } else {
        this.$set(item, keyName, false);
      }
    },
      getInfoList() {
          this.listLoading = true;
          this.$http({
              url: `/buz/endorsement/detailInfo`,
              type: 'GET',
              data: {
                  id: this.$route.query.id
              }
          }).then(res => {
              this.infoData = res.data;
              this.listLoading = false;
          });
      },

      getPersonneList() {
          this.listLoading = true;
          this.$http({
              url: '/buz/grouppolicy/page/insures',
              type: 'POST',
              data: {
                  pageSize: this.pageSize,
                  pageNo: this.pageNum,
                  policyNo: this.$route.query.policyNo,
                  endorsementId: this.$route.query.id
              }
          })
              .then(res => {
                  this.tableData = res.data;
                  this.total = res.total;
                  this.listLoading = false;
              })
              .catch(e => {
                  this.listLoading = false;
              });
      },

      //分页切换页码
      pageChange(pageNum) {
          this.pageNum = pageNum;
          this.getPersonneList();
      }
  }
};
</script>

<style lang="scss" scoped>
.back-btn {
  float: right;
}

.title {
  font-weight: bold;
  font-size: 16px;
  color: #3c464f;
  margin-bottom: 15px;
  display: flex;
  align-items: center;

  .left-line {
      height: 15px;
      width: 3px;
      background: #236dff;
      border-radius: 2px;
  }

  .title-desc {
      margin-left: 5px;
  }
}

.table {
  margin-bottom: 50px;

  .table-info {
      min-width: 1400px;
      display: flex;
      width: 100%;
      border: 1px solid #e9e9e9;
      border-bottom: none;
      height: 40px;
      line-height: 40px;

      &.b-border {
          border: 1px solid #e9e9e9;
      }

      .table-left {
          display: flex;

          flex: 1;

          .label {
              text-align: center;
              flex: 1;
              background: #f7f7f7;
          }

          .value {
              text-align: center;
              border-left: 1px solid #e9e9e9;
              border-right: 1px solid #e9e9e9;
              flex: 4;
          }
      }

      .table-right {
          display: flex;
          flex: 1;

          .label {
              text-align: center;
              flex: 1;
              background: #f7f7f7;
          }

          .value {
              text-align: center;
              border-left: 1px solid #e9e9e9;
              flex: 4;
          }
      }
  }
}
.eye-icon {
    cursor: pointer;
    margin-left: 5px;
  }
</style>
